import React from 'react';
import PropTypes from 'prop-types';
import Option from '../entertainmentOption/EntertainmentOption';
import { getDateLabel, getSlotColor } from '../../utils';
import './CancelModal.scss';

const CancelModal = ({ options, checked, onCancel, onNone }) => (
  <div className="cancel-modal">
    <div className="cancel-modal-container">
      <div className="message">Which of the sessions would you like to cancel?</div>
      {
        options
          .map((option, index) => (checked.filter(({ slotId }) => slotId === option.code).length > 0 ? { ...option, color: getSlotColor(index) } : null))
          .filter(option => !!option)
          .map(({ color, code, singleDate, duration }, index) => (
            <Option
              key={index}
              checked
              color={color}
              label={getDateLabel({ singleDate, duration })}
              onOptionClick={() => onCancel(code)}
            />
          ))
      }
      <div className="none-button" onClick={onNone}>None</div>
    </div>
  </div>
);

CancelModal.propTypes = {
  options: PropTypes.array.isRequired,
  checked: PropTypes.array.isRequired,
  onCancel: PropTypes.func.isRequired,
  onNone: PropTypes.func.isRequired,
};

export default CancelModal;
